/**
 * A semana em curso — de segunda a domingo.
 *
 * Segunda, e não domingo, porque é a semana do widget Agenda e a que o
 * escritório usa: prazo processual corre em dia útil, e a pergunta é sempre
 * "dá tempo antes do fim de semana?".
 *
 * Mora aqui, e não na tela que precisou dela primeiro, porque duas telas já
 * fazem a mesma pergunta: o selo de prazo (se escreve o dia da semana) e a
 * agenda do calendário (como rotula cada dia).
 */

/** A segunda-feira da semana de `d`, à meia-noite local. */
export function segundaDaSemana(d: Date): Date {
  const recuo = (d.getDay() + 6) % 7; // domingo (0) recua 6; segunda, nenhum
  return new Date(d.getFullYear(), d.getMonth(), d.getDate() - recuo);
}

/** `d` cai na semana em curso? */
export function naSemanaCorrente(d: Date, agora: Date = new Date()): boolean {
  const seg = segundaDaSemana(agora);
  const depoisDoDomingo = new Date(seg.getFullYear(), seg.getMonth(), seg.getDate() + 7);
  return d >= seg && d < depoisDoDomingo;
}
